module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showThankyou),
      expression: "!showThankyou"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('name')
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-12 with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true,
        partnershipCheckEmail: true
      }),
      expression: "{ required: true, email: true, partnershipCheckEmail: true}"
    }],
    class: {
      'border-red': _vm.errors.has('email') || _vm.errors.has('partnershipCheckEmail')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailCheck.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3484/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('email', 'partnershipCheckEmail')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "tel",
      "min": "8",
      "max": "12",
      "placeholder": "Phone",
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organisation),
      expression: "organisation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('organisation')
    },
    attrs: {
      "name": "organisation",
      "type": "text",
      "placeholder": "Organisation",
      "autocomplete": "organization"
    },
    domProps: {
      "value": (_vm.organisation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organisation = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showEnquiry) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enquiry),
      expression: "enquiry"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('enquiry')
    },
    attrs: {
      "name": "enquiry",
      "placeholder": "Enquiry type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.enquiry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Enquiry type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Philanthropy"
    }
  }, [_vm._v("Philanthropy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Business"
    }
  }, [_vm._v("Business")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": _vm.messagePlaceholder,
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "word-count"
  }, [_vm._v(_vm._s(255 - (_vm.message ? _vm.message.length : 0) + ' Char'))]), _vm._v(" "), (_vm.showOptin) ? _c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optin),
      expression: "optin"
    }],
    attrs: {
      "type": "checkbox",
      "id": "opt-in",
      "name": "opt-in"
    },
    domProps: {
      "checked": Array.isArray(_vm.optin) ? _vm._i(_vm.optin, null) > -1 : (_vm.optin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.optin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.optin = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.optin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.optin = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  }), _vm._v("I would like to receive news and updates from WWF-Australia")])]) : _vm._e(), _vm._v(" "), (_vm.showOptin) ? _c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.largeProject),
      expression: "largeProject"
    }],
    attrs: {
      "type": "checkbox",
      "id": "largeProject",
      "name": "largeProject"
    },
    domProps: {
      "checked": Array.isArray(_vm.largeProject) ? _vm._i(_vm.largeProject, null) > -1 : (_vm.largeProject)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.largeProject,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.largeProject = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.largeProject = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.largeProject = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "checkbox"
  }), _vm._v("I would like to be contacted regarding impact projects ($50K+)\n            ")])]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProfanity),
      expression: "isProfanity"
    }],
    staticClass: "alert-box"
  }, [_vm._v("No bad words! Please change your message.")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-116c63e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/forms/PartnershipsForm.vue
// module id = 641
// module chunks = 0